var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_document",
            title: "Klagepositionen",
          },
          on: { save: _vm.saveLawsuitData },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Reparaturkosten",
                  property: "repairAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Geleistete Zahlungen",
                  property: "repairPaidAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Berechtigte Kürzung",
                  property: "repairReductionAmount",
                  type: "currency",
                },
                on: { change: _vm.recalculateRepairRemainingAmount },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  currency: "",
                  "form-context": _vm.formContext,
                  label: "Offene Forderung",
                  property: "repairRemainingAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Grund der Kürzung",
                  property: "repairReductionReason",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Mietwagenkosten",
                  property: "rentalAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Geleistete Zahlungen",
                  property: "rentalPaidAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Berechtigte Kürzung",
                  property: "rentalReductionAmount",
                  type: "currency",
                },
                on: { change: _vm.recalculateRentalRemainingAmount },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  currency: "",
                  "form-context": _vm.formContext,
                  label: "Offene Forderung",
                  property: "rentalRemainingAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Grund der Kürzung",
                  property: "rentalReductionReason",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Klage eingereicht am",
                  property: "lawsuitFiledDate",
                  type: "datepicker",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gerichtstermin am",
                  property: "courtDate",
                  type: "datepicker",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Eingeklagte Position",
                  property: "claimedPosition",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  currency: "",
                  "form-context": _vm.formContext,
                  label: "Klagebetrag",
                  property: "claimedAmount",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label:
                    "Verkündungstermine bzw. Urteilsverkündung eingereicht am",
                  property: "judgmentDate",
                  type: "datepicker",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Abschluss des Verfahrens inkl. Verfahrensausgang",
                  property: "lawsuitOutcome",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Grund für Aktenabschluss",
                  property: "recordClosedReason",
                  type: "text",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }